<template>
    <div class="rounded-lg border-2 border-gray-300 py-2 px-3 shadow-lg mt-3 md:mt-6">
        <div class="flex justify-between">
            <div class="font-semibold text-gray-900">
                {{ question.title }}
            </div>
            <div v-if="question.links.question_review_store">
                <QuestionReviewForm :url="question.links.question_review_store" />
            </div>
        </div>
        <div v-if="question.description">
            <QuestionDescriptionDisplay :question="question" />
        </div>
        <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="question.image_path">
            <img :src="question.image_path" alt="cover" class="h-auto" />
        </div>
        <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="question.shared_image">
            <ZoomableImage :src="question.shared_image">
                <img :src="question.shared_image" alt="cover" class="md:w-1/2 h-auto" />
            </ZoomableImage>
        </div>
        <div class="mt-3 p-2" v-if="question.graph">
            <QuestionLineGraph :data="question.graph" v-if="question.graph.type === 'R1Did'" />
            <GraphToolbox
                :elements="question.graph.elements"
                :graph="question.graph.graph"
                v-if="question.graph.type === 'GraphToolbox'"
            />
            <GraphFunctionPlot
                :elements="question.graph.elements"
                :graph="question.graph.graph"
                v-if="question.graph.type === 'GraphFunctionPlot'"
            />
        </div>
        <component
            :is="question.type"
            :question="question"
            :students="students"
            :with-percent="isTeacherMode"
            :is-teacher-mode="isTeacherMode"
        />
    </div>
</template>
<script>
import QuestionDescriptionDisplay from '@/components/Quiz/QuestionDescriptionDisplay.vue';
import ZoomableImage from '@/components/ZoomableImage.vue';
import QuestionReviewForm from '@/components/QuestionReviewForm.vue';
import QuestionLineGraph from '@/components/Quiz/QuestionLineGraph.vue';
import QuestionGeneralReview from '@/components/Quiz/Review/QuestionGeneralReview.vue';
import QuestionOrderElementsReview from '@/components/Quiz/Review/QuestionOrderElementsReview.vue';
import QuestionShortAnswerReview from './Quiz/Review/QuestionShortAnswerReview.vue';
import GraphToolbox from './Quiz/GraphToolbox.vue';
import GraphFunctionPlot from './Quiz/GraphFunctionPlot.vue';

export default {
    name: 'QuestionReviewDisplay',
    components: {
        GraphFunctionPlot,
        GraphToolbox,
        QuestionDescriptionDisplay,
        QuestionLineGraph,
        QuestionReviewForm,
        ZoomableImage,
        'multiple-choice': QuestionGeneralReview,
        'short-answer': QuestionShortAnswerReview,
        'true-false': QuestionGeneralReview,
        'order-phrase': QuestionGeneralReview,
        'order-elements': QuestionOrderElementsReview,
        'math-fraction': QuestionGeneralReview,
        'math-number-with-tolerance': QuestionGeneralReview,
        'multiple-answer': QuestionGeneralReview,
        'math-xyz-answers': QuestionGeneralReview,
        'math-multiple-magnitudes': QuestionGeneralReview,
        'math-prime-factors': QuestionGeneralReview,
        'math-polynomial-operation': QuestionGeneralReview,
        'math-latex-answer': QuestionGeneralReview,
        // { vue_question_review }
    },
    props: {
        students: {
            required: true,
            type: Array,
        },
        isTeacherMode: {
            required: false,
            default: false,
            type: Boolean,
        },
        question: {
            required: true,
            type: Object,
        },
    },
};
</script>
